import momentyz from 'moment-timezone';
import store from './store';
import he from 'he';
import axios from 'axios';
export async function checkauth() {
	if (!store.getters['profile/getCsrf']) {
		//await store.dispatch('profile/csrf');
		//axios.defaults.headers.common['csrf-token'] = store.getters['profile/getCsrf'];
		//axios.defaults.headers.common['xsrf-token'] = store.getters['profile/getCsrf'];
		//axios.defaults.headers.common['x-csrf-token'] = store.getters['profile/getCsrf'];
		//axios.defaults.headers.common['x-xsrf-token'] = store.getters['profile/getCsrf'];
	}
	if (!localStorage.getItem('token')) {
		return false;
	}

	momentyz.tz.setDefault('Europe/Rome');
	let dateexpired = momentyz.utc(momentyz.unix(localStorage.getItem('expired')));
	let datenow = momentyz.utc(new Date());

	// il rinnovo puo' essere rifiutato dal backend anche con un refresh token valido: succede quando
	// l'utente o la sua azienda vengono disattivati mentre la sessione e' aperta. In quel caso la
	// sessione va chiusa qui, altrimenti si resta dentro con un token scaduto e ogni chiamata fallisce.
	// Il `false` finale basta: le rotte fanno gia' next('/login') quando checkauth lo restituisce.
	const renew = async () => {
		const resp = await store.dispatch('profile/refreshToken');
		if (!resp.status) {
			await store.dispatch('profile/logout');
			return false;
		}
		store.dispatch('socket/socket_login', {});
		return true;
	};

	if (datenow > dateexpired) {
		if (!(await renew())) {
			return false;
		}
	}
	if (localStorage.getItem('token') && store.getters['profile/getAutenticate'] === 0) {
		if (!(await renew())) {
			return false;
		}
	}

	return true;
}
/**
 * Il profilo ha il Sito Ecommerce realizzato col nostro framework.
 *
 * Il nome del service e' parte della condizione perche' anche shopify/woocommerce sono
 * `type: 'framework'`: senza, basterebbe un negozio esterno collegato per aprire la sezione.
 */
export async function hasWebsiteFramework() {
	const status = await store.dispatch('services/getServiceFetchActive', ['website']);
	return Array.isArray(status) && status.some(el => el.service === 'website' && el.type === 'framework' && el.active === true);
}

export async function discount(price, pricevat, vat, percent) {
	let mul = Math.abs(percent / 100 - 1);
	let discountPrice = (price * mul).toFixed(3);
	let vatValue = vat / 100 + 1;
	let discountPriceVat = (discountPrice * vatValue).toFixed(2);
	return {
		discountPrice,
		discountPriceVat,
	};
}
export async function discountPercent(origin, discount) {
	let percent = Math.abs((discount * 100) / origin - 100);
	return percent.toFixed(2);
}

export async function slugify(str, separator) {
	str = str.toString().replace(/^\s+|\s+$/g, ''); // trim
	str = str.toLowerCase();

	let from = ['а', 'б', 'в', 'г', 'д', 'е', 'ж', 'з', 'и', 'й', 'к', 'л', 'м', 'н', 'о', 'п', 'р', 'с', 'т', 'у', 'ф', 'х', 'ц', 'ч', 'ш', 'щ', 'ъ', 'ь', 'ю', 'я'];
	let to = ['a', 'b', 'v', 'g', 'd', 'e', 'zh', 'z', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'r', 's', 't', 'u', 'f', 'h', 'c', 'ch', 'sh', 'sht', 'y', '', 'iu', 'ia'];
	for (let key in from) {
		str = str.replace(new RegExp(from[key], 'g'), to[key]);
	}

	str = str
		.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
		.replace(/\s+/g, separator) // collapse whitespace and replace by -
		.replace(/-+/g, separator); // collapse dashes

	return str;
}

function decodeHtmlEntitiesBrowser(str) {
	if (typeof str !== 'string') return '';

	const doc = new DOMParser().parseFromString(str, 'text/html');

	// ✅ IMPORTANTISSIMO: textContent decodifica le entità e ti restituisce "<p>...</p>"
	return (doc.documentElement?.textContent || '').trim();
}

function normalize(text) {
	return text
		.replace(/\u00A0/g, ' ')
		.replace(/[ \t]+/g, ' ')
		.replace(/\s+([,.;:!?])/g, '$1')
		.replace(/([,.;:!?])([A-Za-zÀ-ÖØ-öø-ÿ])/g, '$1 $2')
		.replace(/[ \t]+\n/g, '\n')
		.replace(/\n{3,}/g, '\n\n')
		.trim();
}

export async function cleanPreserveOrder(rawHtmlEscaped) {
	let decodetext = he.decode(rawHtmlEscaped || '');
	const cleanedHtml = await cleanHtml(decodetext);
	//console.log(cleanedHtml);

	const prettyText = htmlToPrettyText(cleanedHtml);
	//console.log(prettyText);
	return prettyText;

	// ... existing code ...
	// 1) decodifica entità -> HTML vero
	/*const decoded = decodeHtmlEntitiesBrowser(rawHtmlEscaped);

	// ✅ guard: input vuoto / non stringa
	if (typeof decoded !== 'string' || decoded.trim() === '') {
		return '';
	}

	// ✅ fallback per ambienti senza DOM (SSR/Node/Jest)
	const hasDOM = typeof DOMParser !== 'undefined' && typeof NodeFilter !== 'undefined' && typeof document !== 'undefined';

	if (!hasDOM) {
		// blocchi -> newline, poi strip tag rimanenti
		const text = decoded
			.replace(/<\/(p|h1|h2|h3|li)>/gi, '\n')
			.replace(/<(p|h1|h2|h3)[^>]*>/gi, '')
			.replace(/<li[^>]*>/gi, '- ')
			.replace(/<br\s*\/?>/gi, '\n')
			.replace(/<[^>]+>/g, '')
			.replace(/\n{3,}/g, '\n\n')
			.replace(/[ \t]+\n/g, '\n')
			.trim();

		return normalize(text);
	}

	// 2) parse HTML
	const doc = new DOMParser().parseFromString(decoded, 'text/html');

	// 3) cammina in ordine i soli ELEMENT_NODE
	const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_ELEMENT);
	const lines = [];

	const isBlock = tag => ['p', 'h1', 'h2', 'h3', 'li'].includes(tag);

	while (walker.nextNode()) {
		const el = walker.currentNode;
		const tag = el.tagName?.toLowerCase();
		if (!tag || !isBlock(tag)) continue;

		const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
		if (!text) continue;

		if (tag === 'li') {
			lines.push(`- ${text}`);
			continue;
		}

		lines.push(text);
		lines.push('');
	}

	// 4) normalizza e sistema accapo
	return normalize(lines.join('\n'));*/
}
async function checkObject(json) {
	if (json.length > 0) {
		let count = 0;
		let full = 0;
		for (const [key, value] of Object.entries(json[0])) {
			console.log(key, value);
			if (key !== 'marketplace_id' && key !== 'language_tag') {
				count++;
				if (value !== '' || typeof value !== 'string') {
					full++;
				}
			}
		}
		if (full === count) {
			return true;
		} else {
			return false;
		}
	}
}
export async function cleanObjectEmpty(json) {
	for (const [key, value] of Object.entries(json.attributes)) {
		//console.log(key, value);
		const response = await checkObject(value);
		if (!response) {
			delete json.attributes[key];
		}
	}
}
const DEFAULT_META_KEYS = new Set(['marketplace_id', 'language_tag', 'lang', 'locale']);

function isPlainObject(v) {
	return v !== null && typeof v === 'object' && !Array.isArray(v);
}

function isEmptyScalar(v) {
	// vuoti veri: null/undefined/stringa vuota/spazi
	return v === null || v === undefined || (typeof v === 'string' && v.trim() === '');
}

function hasMeaningfulData(obj, metaKeys) {
	// "dato reale" = almeno una chiave NON meta presente
	return Object.keys(obj).some(k => !metaKeys.has(k));
}

/**
 * Pulisce ricorsivamente un JSON:
 * - elimina null/undefined/"" (anche "   ")
 * - pulisce dentro array e oggetti
 * - elimina array vuoti e oggetti vuoti
 * - elimina oggetti che, dopo la pulizia, contengono SOLO meta keys (marketplace_id, language_tag, ...)
 * - NON elimina 0 o false (valori validi)
 *
 * Ritorna `undefined` se il nodo va eliminato.
 */
export function pruneDeep(input, opts = {}) {
	const metaKeys = opts.metaKeys ? new Set(opts.metaKeys) : DEFAULT_META_KEYS;

	function prune(node) {
		// scalare
		if (!isPlainObject(node) && !Array.isArray(node)) {
			return isEmptyScalar(node) ? undefined : node;
		}

		// array
		if (Array.isArray(node)) {
			const cleaned = node.map(prune).filter(v => v !== undefined);

			return cleaned.length ? cleaned : undefined;
		}

		// oggetto
		const out = {};

		for (const [k, v] of Object.entries(node)) {
			const cleaned = prune(v);
			if (cleaned !== undefined) out[k] = cleaned;
		}

		// se oggetto vuoto -> elimina
		if (Object.keys(out).length === 0) return undefined;

		// se rimangono solo meta keys -> elimina
		if (!hasMeaningfulData(out, metaKeys)) return undefined;

		return out;
	}

	const res = prune(input);

	// comodo: se tutto sparisce, ritorna struttura coerente
	if (res === undefined) return Array.isArray(input) ? [] : {};
	return res;
}

/**
 * Helper per SP-API: pulisce solo attributes
 */
export function cleanSpApiAttributes(payload, opts = {}) {
	if (!payload || typeof payload !== 'object') return payload;
	if (!payload.attributes || typeof payload.attributes !== 'object') return payload;

	payload.attributes = pruneDeep(payload.attributes, opts);
	return payload;
}
/**
 * Pulisce HTML:
 * - rimuove script/style/commenti
 * - rimuove attributi data-*, on*, style, class (configurabile)
 * - whitelist di tag
 * - normalizza whitespace e unicode (NFC)
 */
export function cleanHtml(inputHtml, options = {}) {
	const {
		allowedTags = new Set(['p', 'br', 'strong', 'b', 'em', 'i', 'u', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'a']),
		keepAttributes = {
			a: new Set(['href', 'title', 'target', 'rel']),
		},
		dropClass = true,
		dropStyle = true,
	} = options;

	if (!inputHtml || typeof inputHtml !== 'string') return '';

	const doc = new DOMParser().parseFromString(inputHtml, 'text/html');
	const body = doc.body;

	// rimuovi commenti
	const walker = doc.createTreeWalker(body, NodeFilter.SHOW_COMMENT, null);
	const comments = [];
	while (walker.nextNode()) comments.push(walker.currentNode);
	comments.forEach(n => n.remove());

	// rimuovi script/style
	body.querySelectorAll('script, style, noscript').forEach(n => n.remove());

	// sanifica elementi
	const all = Array.from(body.querySelectorAll('*'));
	for (const el of all) {
		const tag = el.tagName.toLowerCase();

		// se tag non consentito: unwrap (tieni testo/figli)
		if (!allowedTags.has(tag)) {
			const frag = doc.createDocumentFragment();
			while (el.firstChild) frag.appendChild(el.firstChild);
			el.replaceWith(frag);
			continue;
		}

		// pulizia attributi
		for (const attr of Array.from(el.attributes)) {
			const name = attr.name.toLowerCase();

			// elimina data-*
			if (name.startsWith('data-')) {
				el.removeAttribute(attr.name);
				continue;
			}

			// elimina handler on*
			if (name.startsWith('on')) {
				el.removeAttribute(attr.name);
				continue;
			}

			if (dropStyle && name === 'style') {
				el.removeAttribute(attr.name);
				continue;
			}

			if (dropClass && name === 'class') {
				el.removeAttribute(attr.name);
				continue;
			}

			// whitelist attributi per tag
			const allowedForTag = keepAttributes[tag];
			if (allowedForTag && allowedForTag.has(name)) continue;

			// se non è in whitelist → rimuovi
			if (allowedForTag) el.removeAttribute(attr.name);
			else el.removeAttribute(attr.name);
		}

		// hardening link
		if (tag === 'a') {
			const href = el.getAttribute('href') || '';
			// blocca javascript:
			if (/^\s*javascript:/i.test(href)) el.removeAttribute('href');
			// sicurezza target blank
			if (el.getAttribute('target') === '_blank') {
				const rel = (el.getAttribute('rel') || '').toLowerCase();
				if (!rel.includes('noopener')) el.setAttribute('rel', (rel + ' noopener').trim());
			}
		}
	}

	// normalizza spazi e unicode
	let out = body.innerHTML;

	out = out
		.normalize('NFC')
		.replace(/\u00A0/g, ' ') // nbsp → spazio
		.replace(/[ \t]+\n/g, '\n')
		.replace(/\n[ \t]+/g, '\n')
		.replace(/[ \t]{2,}/g, ' ')
		.trim();

	return out;
}

/**
 * Converte HTML in testo leggibile:
 * - blocchi → newline
 * - inline → spazio (per evitare parole attaccate) + tag eliminati
 */
export function htmlToPrettyText(inputHtml) {
	if (!inputHtml || typeof inputHtml !== 'string') return '';

	const doc = new DOMParser().parseFromString(inputHtml, 'text/html');
	const body = doc.body;

	// set tag "block" che devono generare a capo
	const BLOCK = new Set([
		'p',
		'div',
		'section',
		'article',
		'header',
		'footer',
		'main',
		'aside',
		'h1',
		'h2',
		'h3',
		'h4',
		'h5',
		'h6',
		'ul',
		'ol',
		'li',
		'table',
		'thead',
		'tbody',
		'tfoot',
		'tr',
		'blockquote',
		'pre',
		'hr',
		'br',
	]);

	// tag inline che vogliamo solo “spaziare”
	const INLINE_SPACE = new Set(['span', 'strong', 'b', 'em', 'i', 'u', 'small', 'mark', 'a', 'code', 'sup', 'sub']);

	function textFromNode(node) {
		if (node.nodeType === Node.TEXT_NODE) {
			return node.nodeValue;
		}

		if (node.nodeType !== Node.ELEMENT_NODE) return '';

		const tag = node.tagName.toLowerCase();

		// br/hr: newline secco
		if (tag === 'br' || tag === 'hr') return '\n';

		// calcola testo figli
		let inner = '';
		for (const child of Array.from(node.childNodes)) {
			inner += textFromNode(child);
		}

		// normalizza per sicurezza
		inner = inner.replace(/\u00A0/g, ' ');

		// blocchi: metti newline attorno
		if (BLOCK.has(tag)) {
			// per LI metti un bullet opzionale (se non lo vuoi, rimuovi "• ")
			if (tag === 'li') {
				const cleaned = inner.trim();
				return cleaned ? `\n• ${cleaned}\n` : '\n';
			}
			return `\n${inner}\n`;
		}

		// inline: aggiungi spazi “di sicurezza”
		if (INLINE_SPACE.has(tag)) {
			// spazio ai lati per evitare concatenazioni
			return ` ${inner} `;
		}

		// default: non aggiunge nulla
		return inner;
	}

	let out = '';
	for (const child of Array.from(body.childNodes)) {
		out += textFromNode(child);
	}

	// cleanup finale: spazi e newline puliti
	out = out
		.normalize('NFC')
		.replace(/[ \t]+\n/g, '\n')
		.replace(/\n[ \t]+/g, '\n')
		.replace(/[ \t]{2,}/g, ' ')
		.replace(/\n{3,}/g, '\n\n')
		.trim();

	return out;
}

/**
 * Colore percepito come scuro? Serve a scegliere il colore del testo sopra uno sfondo
 * arbitrario (tag ordine, colori status): bianco su scuro, nero su chiaro.
 * Accetta un esadecimale `#RRGGBB` (gli eventuali caratteri di alpha oltre il sesto
 * vengono ignorati); soglia 140 sulla luminanza percettiva.
 */
export function isDarkColor(hex) {
	if (!hex || hex.length < 7) return false;
	const color = hex.replace('#', '');
	const r = parseInt(color.substr(0, 2), 16);
	const g = parseInt(color.substr(2, 2), 16);
	const b = parseInt(color.substr(4, 2), 16);
	const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
	return luminance < 140;
}

/**
 * Elenco dei valori configurati per un attributo di tipo `select`.
 * Difensivo: da import o da modifiche manuali il campo puo' arrivare come stringa CSV.
 */
function optionChoices(option) {
	if (option.type !== 'select') return [];
	const raw = Array.isArray(option.value) ? option.value : String(option.value || '').split(',');
	return raw.map(el => String(el).trim()).filter(el => el !== '');
}

/**
 * Idrata gli attributi aggiuntivi di un prodotto (Impostazioni > Prodotti > Attributi aggiuntivi).
 *
 * Si itera SEMPRE sulla configurazione del profilo (unica fonte di verita') e per ognuna si
 * recupera l'eventuale valore salvato sull'item: stesso schema del merge dei tab aggiuntivi in
 * components/items/Edit.vue. Gli attributi disattivati o cancellati dalla configurazione
 * spariscono dal form; i valori restano in Mongo finche' il prodotto non viene risalvato.
 *
 * `choices` serve solo al render del tab: va tolto con sanitizeItemOptions() prima del salvataggio.
 */
export function buildItemOptions(config, saved) {
	const active = (config || []).filter(el => el && el.is_active !== false);

	return active
		.slice()
		.sort((a, b) => (a.position || 0) - (b.position || 0))
		.map(option => {
			const found = (saved || []).find(el => String(el._option) === String(option._id));
			const choices = optionChoices(option);

			let value = found ? found.value : undefined;
			if (value === undefined || value === null) {
				value = option.type === 'boolean' ? false : option.type === 'integer' ? null : '';
			}

			// il tipo puo' essere cambiato in configurazione dopo il salvataggio: il valore
			// vecchio non e' piu' valido e va ricastato (o svuotato, se fuori dall'elenco)
			if (option.type === 'boolean') value = value === true || value === 'true' || value === 1;
			if (option.type === 'integer') value = value === '' || value === null ? null : parseInt(value, 10);
			if (option.type === 'select') value = choices.includes(value) ? value : '';
			if (option.type === 'string') value = String(value);

			return {
				_option: String(option._id),
				type: option.type,
				label: option.label,
				choices: choices,
				value: value,
			};
		});
}

/** Rimuove i campi di sola presentazione (`choices`) prima del POST a items/update. */
export function sanitizeItemOptions(rows) {
	return (rows || []).map(row => ({
		_option: row._option,
		type: row.type,
		label: row.label,
		value: row.value,
	}));
}

/** Rende sicuro un testo da mostrare con v-html (es. lo snackbar): niente tag interpretati. */
export function escapeHtml(value) {
	return String(value == null ? '' : value)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
}

/**
 * Testo dell'avviso per un errore axios: il `message` del backend (con la lingua, se c'è),
 * altrimenti il messaggio di axios. Già escapato: lo snackbar lo mostra con v-html.
 */
export function testoErroreBackend(err) {
	const data = (err && err.response && err.response.data) || {};
	if (!data.message || typeof data.message !== 'string') {
		return escapeHtml(err && err.message);
	}
	return escapeHtml(data.lang ? `${data.message} (lingua: ${data.lang})` : data.message);
}
